import TrialHeaderCountdown from '../../../layouts/TrialHeaderCountdown'

import { LessonListContent } from '../../../components/LessonListContent'

import { ContentType } from '../../../types/trialLessons'
import { useCampaignAndCountdownStatus } from '../../../utils/campaignCountdown'
import { CurrentUser } from '../../../types/currentUser'
import { Reservation } from '../../../types/reservation'
import { useRedirectToReschedule } from '../../../hooks/useRedirectToReschedule'
import TrialHeaderForAB from '../../../layouts/TrialHeaderForAB'
import { TrialLessonContentForAB } from '../../../components/TrialLessonContentForAB'
import { AwardContentForAB } from '../../../components/AwardContentForAB'
import TrialLessonSatisfiedBannerForPc from '../../../public/trial_lesson_satisfied_banner_for_pc.png'
import TrialLessonSatisfiedBannerForSp from '../../../public/trial_lesson_satisfied_banner_for_sp.png'
import { useMediaQuery } from '@material-ui/core'
import { THRESHOLD_DESKTOP_WIDTH } from '../../../utils/constants'

type Props = {
  contentType: ContentType
  currentUser?: CurrentUser
  jwtToken: string
  likesReservation: Reservation | null
}

const TrialLessons = ({
  contentType,
  currentUser,
  jwtToken,
  likesReservation,
}: Props) => {
  const { isCountdownActive } = useCampaignAndCountdownStatus()
  const isPc = useMediaQuery(`(min-width:${THRESHOLD_DESKTOP_WIDTH}px)`)

  // 有効な予約があれば、振替ページにリダイレクト
  useRedirectToReschedule(likesReservation)

  return (
    <>
      <div className="bg-white mx-auto mb-10">
        {isCountdownActive && <TrialHeaderCountdown />}
        <TrialHeaderForAB isCountdownActive={isCountdownActive} />
        <TrialLessonContentForAB isPc={isPc} />
        <AwardContentForAB isPc={isPc} />
        <div className="text-center">
          <img
            src={
              isPc
                ? TrialLessonSatisfiedBannerForPc.src
                : TrialLessonSatisfiedBannerForSp.src
            }
            className="max-w-full h-auto"
          />
        </div>
        <section
          className="mt-12 mx-auto mb-8 text-center"
          id="reservation-step-summary"
        >
          <LessonListContent
            contentType={contentType}
            jwtToken={jwtToken}
            currentUser={currentUser}
          />
        </section>
      </div>
    </>
  )
}

export const getServerSideProps = async () => {
  const contentType = 'onlyOtl'

  return {
    props: { contentType },
  }
}

export default TrialLessons
